<template>
  <div :class="['progress-star lingos-remaining']">{{ lingos }}L</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ActivityLingos extends Vue {
  @Prop({ type: Number, required: true })
  public lingos!: number;
}
</script>

<style lang="scss" scoped>
.lingos-remaining {
  @include d-flex-center;

  border-radius: 100%;
  background-color: #f3e80f;
  border: 3px solid white;
  font-size: 34px;
  font-weight: bold;
  color: white;
  box-shadow: 1px 2px 2px #1b75bb;

  width: 88px;
  height: 88px;

  @media (max-width: #{$mobile}px) {
    font-size: 24px;
  }
}
</style>
